(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope) => {
      const sections = Array.from(scope.querySelectorAll('.cb-gallery-reviews[data-cb-photo-loop]'));
      if (scope.matches?.('.cb-gallery-reviews[data-cb-photo-loop]')) sections.unshift(scope);
      sections.forEach((section) => {
        if (section.dataset.cbPhotoReady) return;
        section.dataset.cbPhotoReady = 'true';
        const viewport = section.querySelector('[data-cb-photo-viewport]');
        const group = section.querySelector('[data-cb-photo-group]');
        if (!viewport || !group) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const state = { focus: false, pointer: false, visible: true };
        let distance = group.getBoundingClientRect().width + 12;
        if ('ResizeObserver' in window) new ResizeObserver(() => { distance = group.getBoundingClientRect().width + 12; }).observe(group);
        let last = 0;
        const tick = (now) => {
          if (!reduced.matches && !state.focus && !state.pointer && state.visible && document.visibilityState === 'visible' && viewport.scrollWidth - viewport.clientWidth > distance) {
            if (last) viewport.scrollLeft += Math.min((now - last) * .032, 2.5);
            if (viewport.scrollLeft >= distance) viewport.scrollLeft -= distance;
          }
          last = now;
          if (section.isConnected) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        section.addEventListener('focusin', (event) => { state.focus = event.target.matches(':focus-visible'); });
        section.addEventListener('focusout', () => { state.focus = false; });
        viewport.addEventListener('pointerdown', () => { state.pointer = true; }, { passive: true });
        viewport.addEventListener('pointerup', () => { setTimeout(() => { state.pointer = false; }, 1200); }, { passive: true });
        viewport.addEventListener('pointercancel', () => { state.pointer = false; });
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(([entry]) => { state.visible = entry.isIntersecting; }, { rootMargin: '200px' });
          observer.observe(section);
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-video-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope) => {
      const sections = Array.from(scope.querySelectorAll('.cb-films[data-cb-loop-section]'));
      if (scope.matches?.('.cb-films[data-cb-loop-section]')) sections.unshift(scope);
      sections.forEach((section) => {
        if (section.dataset.cbLoopReady) return;
        section.dataset.cbLoopReady = 'true';
        const viewport = section.querySelector('[data-cb-loop-viewport]');
        const group = section.querySelector('[data-cb-loop-group]');
        if (!viewport || !group) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const state = { hover: false, focus: false, pointer: false, playing: false };
        const isPaused = () => Object.values(state).some(Boolean);
        let last = 0;
        const tick = (now) => {
          if (!reduced.matches && !isPaused() && group.scrollWidth > viewport.clientWidth) {
            if (last) viewport.scrollLeft += Math.min((now - last) * .028, 2);
            if (viewport.scrollLeft >= group.scrollWidth + 16) viewport.scrollLeft -= group.scrollWidth + 16;
          }
          last = now;
          if (section.isConnected) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        section.addEventListener('mouseenter', () => { state.hover = true; });
        section.addEventListener('mouseleave', () => { state.hover = false; });
        section.addEventListener('focusin', () => { state.focus = true; });
        section.addEventListener('focusout', () => { state.focus = false; });
        viewport.addEventListener('pointerdown', () => { state.pointer = true; }, { passive: true });
        viewport.addEventListener('pointerup', () => { setTimeout(() => { state.pointer = false; }, 2500); }, { passive: true });
        viewport.querySelectorAll('video').forEach((video) => {
          video.addEventListener('play', () => { state.playing = true; });
          video.addEventListener('pause', () => { state.playing = Array.from(viewport.querySelectorAll('video')).some((item) => !item.paused); });
        });
        section.querySelectorAll('[data-cb-shift]').forEach((button) => button.addEventListener('click', () => {
          viewport.scrollBy({ left: Number(button.dataset.cbShift) * 328, behavior: reduced.matches ? 'auto' : 'smooth' });
        }));
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-written-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope) => {
      const sections = Array.from(scope.querySelectorAll('[data-cb-voices]'));
      if (scope.matches?.('[data-cb-voices]')) sections.unshift(scope);
      sections.forEach((section) => {
        if (section.dataset.cbVoicesReady) return;
        section.dataset.cbVoicesReady = 'true';
        const button = section.querySelector('[data-cb-voices-more]');
        button?.addEventListener('click', () => {
          const hidden = Array.from(section.querySelectorAll('[data-cb-voice][hidden]'));
          hidden.slice(0, 3).forEach((card) => { card.hidden = false; });
          if (hidden.length <= 3) button.hidden = true;
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinnabella-storefront"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPurchasePanel = (scope = document) => {
      const roots = Array.from(scope.querySelectorAll('[data-cb-storefront]'));
      if (scope.matches?.('[data-cb-storefront]')) roots.unshift(scope);
      roots.forEach((root) => {
      const form = root.querySelector('.cb-product-form');
      if (!form || root.dataset.cbPurchaseInitialized === 'true') return;
      root.dataset.cbPurchaseInitialized = 'true';
      const quantityInput = form.querySelector('[data-cb-quantity-input]');
      const variantInput = form.querySelector('[data-cb-variant-input]');
      const price = form.querySelector('[data-cb-button-price]');
      const error = form.querySelector('[data-cb-form-error]');
      const submit = form.querySelector('button[type="submit"]');
      // Some subscription apps replace the Liquid input after render. Use the
      // actual selling_plan field left in the form so the selected plan reaches cart.
      let plan = form.querySelector('[data-cb-selling-plan]') || form.querySelector('[name="selling_plan"]');
      const hasSellingPlans = Boolean(form.querySelector('.cb-bundle input[data-selling-plan-id]:not([data-selling-plan-id=""])'));
      if (!plan && hasSellingPlans) {
        plan = document.createElement('input');
        plan.type = 'hidden';
        plan.name = 'selling_plan';
        form.appendChild(plan);
      }
      const buttonLabel = form.querySelector('[data-cb-button-label]');
      const subscriptionToggle = form.querySelector('[data-cb-subscribe]');
      const billingNote = form.querySelector('[data-cb-billing-note]');
      const mobileBar = root.querySelector('[data-cb-mobile-buybar]');
      const mobileTitle = root.querySelector('[data-cb-mobile-title]');
      const mobilePrice = root.querySelector('[data-cb-mobile-price]');
      const mobileSubmit = root.querySelector('[data-cb-mobile-submit]');
      const gallery = root.querySelector('[data-cb-gallery]');
      let selectedBundle = form.querySelector('.cb-bundle input[type="radio"]:checked');
      const formatPrice = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
      const resolveOffer = (bundle, isSubscription) => {
        if (!bundle?.dataset.variantId) return null;
        if (isSubscription && !bundle.dataset.sellingPlanId) return null;
        const cents = Number(bundle.dataset[isSubscription ? 'subscriptionPriceCents' : 'variantPriceCents']);
        return Number.isFinite(cents) && cents > 0 ? cents : null;
      };

      const updateOffer = () => {
        if (!selectedBundle) return;
        const isSubscription = Boolean(subscriptionToggle?.checked && plan && selectedBundle.dataset.sellingPlanId);
        const jarCount = Number(selectedBundle.value);
        const offerCents = resolveOffer(selectedBundle, isSubscription);
        const displayed = offerCents === null ? '—' : formatPrice(offerCents);
        const deliveryDays = jarCount * 30;
        if (quantityInput) quantityInput.value = '1';
        if (variantInput) variantInput.value = selectedBundle.dataset.variantId || '';
        if (plan) {
          plan.value = isSubscription ? (selectedBundle.dataset.sellingPlanId || '') : '';
          plan.disabled = !isSubscription;
        }
        const isAvailable = selectedBundle.dataset.variantAvailable === 'true';
        if (submit) submit.disabled = offerCents === null || !isAvailable;
        if (buttonLabel) buttonLabel.textContent = offerCents === null ? 'Supply unavailable' : (isAvailable ? 'Add to Cart' : 'Sold Out');
        if (price) price.textContent = displayed;
        if (billingNote) { billingNote.hidden = !isSubscription || offerCents === null; billingNote.textContent = `Charged ${displayed} today and every ${deliveryDays} days. Cancel anytime.`; }
        form.querySelector('.cb-subscribe-toggle')?.classList.toggle('is-selected', isSubscription);
        if (mobileTitle) mobileTitle.textContent = `${selectedBundle.dataset.title} · ${isSubscription ? 'Subscribe' : 'One-time'}`;
        if (mobilePrice) mobilePrice.textContent = displayed;
        if (mobileSubmit) { mobileSubmit.textContent = offerCents === null ? 'Supply unavailable' : isAvailable ? 'Add to Cart' : 'Sold Out'; mobileSubmit.disabled = offerCents === null || !isAvailable; }

        form.querySelectorAll('.cb-bundle input[type="radio"]').forEach((bundle) => {
          const card = bundle.closest('.cb-bundle');
          const cardUnit = card?.querySelector('[data-cb-bundle-unit]');
          const cardSavings = card?.querySelector('[data-cb-bundle-save]');
          const cents = resolveOffer(bundle, isSubscription);
          const quantity = Number(bundle.value);
          if (cardUnit) cardUnit.innerHTML = `${cents === null ? '—' : formatPrice(cents / quantity)}<small>/jar</small>`;
          if (cardSavings) cardSavings.textContent = cents === null ? 'Unavailable' : `${Math.round((1 - cents / (5999 * quantity)) * 100)}% off`;
        });
      };

      root.querySelectorAll('.cb-bundle input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => {
          root.querySelectorAll('.cb-bundle').forEach((label) => label.classList.remove('is-selected'));
          radio.closest('.cb-bundle')?.classList.add('is-selected');
          selectedBundle = radio;
          updateOffer();
        });
      });
      subscriptionToggle?.addEventListener('change', updateOffer);

      if (gallery) {
        const slides = Array.from(gallery.querySelectorAll('[data-cb-slide]'));
        const thumbs = Array.from(root.querySelectorAll('[data-cb-thumbnail]'));
        const counter = root.querySelector('[data-cb-gallery-count]');
        const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        const syncIndex = (index) => {
          const bounded = Math.max(0, Math.min(index, slides.length - 1));
          thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-active', i === bounded);
            thumb.setAttribute('aria-current', String(i === bounded));
          });
          if (counter) counter.textContent = `${bounded + 1} / ${slides.length}`;
        };
        const goTo = (index) => {
          if (!slides.length) return;
          const bounded = Math.max(0, Math.min(index, slides.length - 1));
          gallery.scrollTo({ left: slides[bounded].offsetLeft - slides[0].offsetLeft, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
          syncIndex(bounded);
        };
        thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => goTo(index)));
        root.querySelectorAll('[data-cb-gallery-arrow]').forEach((arrow) => {
          arrow.addEventListener('click', () => goTo(Math.round(gallery.scrollLeft / gallery.clientWidth) + Number(arrow.dataset.cbGalleryArrow)));
        });
        gallery.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          goTo(Math.round(gallery.scrollLeft / gallery.clientWidth) + (event.key === 'ArrowRight' ? 1 : -1));
        });
        let scrollScheduled = false;
        gallery.addEventListener('scroll', () => {
          if (scrollScheduled) return;
          scrollScheduled = true;
          requestAnimationFrame(() => {
            syncIndex(Math.round(gallery.scrollLeft / gallery.clientWidth));
            scrollScheduled = false;
          });
        }, { passive: true });
        syncIndex(0);
      }

      if (mobileSubmit) mobileSubmit.addEventListener('click', () => {
        document.getElementById('dr-divine-offer')?.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          block: 'start'
        });
      });

      if (mobileBar && submit && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          mobileBar.classList.toggle('is-hidden', entry.isIntersecting);
        }, { threshold: 0.25 });
        observer.observe(submit);
      }

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!selectedBundle) return;
        if (submit) {
          submit.disabled = true;
          submit.classList.add('is-loading');
        }
        if (buttonLabel) buttonLabel.textContent = 'Adding…';
        if (mobileSubmit) {
          mobileSubmit.disabled = true;
          mobileSubmit.textContent = 'Adding…';
        }
        if (error) error.hidden = true;
        try {
          const isSubscription = Boolean(subscriptionToggle?.checked && selectedBundle.dataset.sellingPlanId);
          if (resolveOffer(selectedBundle, isSubscription) === null || selectedBundle.dataset.variantAvailable !== 'true') throw new Error('This supply option is not available yet.');
          const purchaseData = new FormData(form);
          purchaseData.set('id', selectedBundle.dataset.variantId);
          purchaseData.set('quantity', '1');
          if (isSubscription) purchaseData.set('selling_plan', selectedBundle.dataset.sellingPlanId);
          else purchaseData.delete('selling_plan');
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: purchaseData
          });
          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(data.description || 'This offer could not be added to your cart.');
          }
          const rootUrl = window.Shopify?.routes?.root || '/';
          const cartUrl = `${rootUrl}cart`;
          window.location.assign(cartUrl);
        } catch (submissionError) {
          if (error) {
            error.textContent = submissionError.message;
            error.hidden = false;
          }
          if (submit) {
            submit.disabled = false;
            submit.classList.remove('is-loading');
          }
          if (buttonLabel) buttonLabel.textContent = 'Add to Cart';
          if (mobileSubmit) {
            mobileSubmit.disabled = false;
            mobileSubmit.textContent = 'Add to Cart';
          }
        }
      });

      updateOffer();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initPurchasePanel(), { once: true });
    } else {
      initPurchasePanel();
    }
    document.addEventListener('shopify:section:load', (event) => initPurchasePanel(event.target));
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinnabella-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dd-offer-countdown')) {
    class DdOfferCountdown extends HTMLElement {
      connectedCallback() {
        this.clock = this.querySelector('[data-countdown-clock]');
        this.time = this.querySelector('[data-countdown-time]');
        this.key = 'dr-divine:offer-timer:2h:v1';
        this.deadline = this.readDeadline();
        this.onVisibility = () => this.update();
        this.onStorage = (event) => {
          if (event.key !== this.key || !event.newValue) return;
          const next = Number(event.newValue);
          if (Number.isSafeInteger(next) && next > 0) {
            this.deadline = Math.min(this.deadline || next, next);
            this.update();
          }
        };
        document.addEventListener('visibilitychange', this.onVisibility);
        window.addEventListener('storage', this.onStorage);
        this.update();
        if (this.deadline > Date.now()) {
          this.interval = window.setInterval(() => this.update(), 1000);
        }
      }

      readDeadline() {
        for (const storageName of ['localStorage', 'sessionStorage']) {
          try {
            const storage = window[storageName];
            const saved = Number(storage.getItem(this.key));
            if (Number.isSafeInteger(saved) && saved > 0) return saved;
            const deadline = Date.now() + 2 * 60 * 60 * 1000;
            storage.setItem(this.key, String(deadline));
            return deadline;
          } catch {}
        }
        return null;
      }

      update() {
        if (!this.clock || !this.time) return;
        const remaining = this.deadline ? Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000)) : 0;
        this.clock.hidden = remaining === 0;
        if (remaining === 0) {
          window.clearInterval(this.interval);
          return;
        }
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;
        this.time.textContent = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.onVisibility);
        window.removeEventListener('storage', this.onStorage);
      }
    }
    customElements.define('dd-offer-countdown', DdOfferCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-product-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dd-review-feed')) {
    customElements.define('dd-review-feed', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController();
        this.cards = [...this.querySelectorAll('[data-dd-review]')];
        this.visible = 4;
        this.button = this.querySelector('[data-dd-more]');
        this.cards.forEach((card, i) => { card.hidden = i >= this.visible; });
        if (this.button) this.button.hidden = this.cards.length <= 4;
        this.button?.addEventListener('click', () => {
          const first = this.cards[this.visible];
          this.visible += 4;
          this.cards.forEach((card, i) => { card.hidden = i >= this.visible; });
          this.button.hidden = this.visible >= this.cards.length;
          const status = this.querySelector('[data-dd-review-status]');
          if (status) status.textContent = Math.min(this.visible, this.cards.length) + ' ' + status.dataset.label;
          if (first) { first.tabIndex = -1; first.focus({ preventScroll: true }); }
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  if (!customElements.get('dd-review-carousel')) {
    customElements.define('dd-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController();
        const signal = this.abort.signal;
        this.rail = this.querySelector('.dd-story__rail');
        const original = this.querySelector('.dd-story__video-group');
        if (!this.rail || !original || Number(this.dataset.count) < 2) return;
        this.querySelectorAll('[data-dd-clone]').forEach(node => node.remove());
        const clone = original.cloneNode(true);
        clone.dataset.ddClone = 'true'; clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('video').forEach(video => { video.tabIndex = -1; });
        const cycleWidth = original.getBoundingClientRect().width + 16;
        const copies = Math.ceil(this.rail.clientWidth / cycleWidth) + 1;
        for (let i = 0; i < copies; i++) this.rail.appendChild(clone.cloneNode(true));
        this.pause = { user: false, hover: false, focus: false, pointer: false, playing: false };
        this.onScreen = false; this.last = 0;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        const start = () => {
          if (!this.frame && this.isConnected && this.onScreen && !document.hidden && !this.motion.matches && !Object.values(this.pause).some(Boolean)) this.frame = requestAnimationFrame(tick);
        };
        const stop = () => { cancelAnimationFrame(this.frame); this.frame = null; this.last = 0; };
        const tick = now => {
          this.frame = null;
          if (this.last) this.rail.scrollLeft += Math.min(now - this.last, 48) * .025;
          this.last = now;
          const cycle = original.getBoundingClientRect().width + 16;
          if (this.rail.scrollLeft >= cycle) this.rail.scrollLeft -= cycle;
          start();
        };
        const update = () => { stop(); start(); };
        const bind = (name, key, value) => this.addEventListener(name, () => { this.pause[key] = value; update(); }, { signal, passive: true });
        bind('mouseenter', 'hover', true); bind('mouseleave', 'hover', false);
        bind('focusin', 'focus', true);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.pause.focus = false; update(); } }, { signal });
        bind('pointerdown', 'pointer', true);
        window.addEventListener('pointerup', () => { this.pause.pointer = false; update(); }, { signal, passive: true });
        window.addEventListener('pointercancel', () => { this.pause.pointer = false; update(); }, { signal, passive: true });
        this.rail.querySelectorAll('video').forEach(video => {
          video.addEventListener('play', () => { this.rail.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); }); this.pause.playing = true; update(); }, { signal });
          const paused = () => { this.pause.playing = [...this.rail.querySelectorAll('video')].some(item => !item.paused); update(); };
          video.addEventListener('pause', paused, { signal }); video.addEventListener('ended', paused, { signal });
        });
        const pauseButton = this.querySelector('[data-dd-pause]');
        pauseButton?.addEventListener('click', () => { this.pause.user = !this.pause.user; pauseButton.setAttribute('aria-pressed', String(this.pause.user)); update(); }, { signal });
        const move = direction => {
          this.pause.user = true; pauseButton?.setAttribute('aria-pressed', 'true'); update();
          const cycle = original.getBoundingClientRect().width + 16;
          if (direction < 0 && this.rail.scrollLeft < 1) this.rail.scrollLeft = cycle;
          if (direction > 0 && this.rail.scrollLeft >= cycle - 1) this.rail.scrollLeft = 0;
          this.rail.scrollBy({ left: direction * (original.firstElementChild.getBoundingClientRect().width + 16), behavior: this.motion.matches ? 'auto' : 'smooth' });
        };
        this.querySelector('[data-dd-prev]')?.addEventListener('click', () => move(-1), { signal });
        this.querySelector('[data-dd-next]')?.addEventListener('click', () => move(1), { signal });
        this.rail.addEventListener('keydown', event => { if (event.target === this.rail && ['ArrowLeft','ArrowRight'].includes(event.key)) { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); } }, { signal });
        document.addEventListener('visibilitychange', update, { signal });
        this.motion.addEventListener('change', update, { signal });
        this.observer = new IntersectionObserver(entries => { this.onScreen = entries[0].isIntersecting; update(); }, { threshold: .1 });
        this.observer.observe(this); this.stop = stop;
      }
      disconnectedCallback() { this.stop?.(); this.observer?.disconnect(); this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dd-review-carousel')) {
    customElements.define('dd-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController();
        const signal = this.abort.signal;
        this.rail = this.querySelector('.dd-story__rail');
        const original = this.querySelector('.dd-story__video-group');
        if (!this.rail || !original || Number(this.dataset.count) < 2 || window.Shopify?.designMode) return;
        this.querySelectorAll('[data-dd-clone]').forEach(node => node.remove());
        const clone = original.cloneNode(true);
        clone.dataset.ddClone = 'true'; clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('video').forEach(video => { video.tabIndex = -1; });
        const cycleWidth = original.getBoundingClientRect().width + 16;
        const copies = Math.ceil(this.rail.clientWidth / cycleWidth) + 1;
        for (let i = 0; i < copies; i++) this.rail.appendChild(clone.cloneNode(true));
        this.pause = { user: false, hover: false, focus: false, pointer: false, playing: false };
        this.onScreen = false; this.last = 0;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        const start = () => {
          if (!this.frame && this.isConnected && this.onScreen && !document.hidden && !this.motion.matches && !Object.values(this.pause).some(Boolean)) this.frame = requestAnimationFrame(tick);
        };
        const stop = () => { cancelAnimationFrame(this.frame); this.frame = null; this.last = 0; };
        const tick = now => {
          this.frame = null;
          if (this.last) this.rail.scrollLeft += Math.min(now - this.last, 48) * .025;
          this.last = now;
          const cycle = original.getBoundingClientRect().width + 16;
          if (this.rail.scrollLeft >= cycle) this.rail.scrollLeft -= cycle;
          start();
        };
        const update = () => { stop(); start(); };
        const bind = (name, key, value) => this.addEventListener(name, () => { this.pause[key] = value; update(); }, { signal, passive: true });
        bind('mouseenter', 'hover', true); bind('mouseleave', 'hover', false);
        bind('focusin', 'focus', true);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.pause.focus = false; update(); } }, { signal });
        bind('pointerdown', 'pointer', true);
        window.addEventListener('pointerup', () => { this.pause.pointer = false; update(); }, { signal, passive: true });
        window.addEventListener('pointercancel', () => { this.pause.pointer = false; update(); }, { signal, passive: true });
        this.rail.querySelectorAll('video').forEach(video => {
          video.addEventListener('play', () => { this.rail.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); }); this.pause.playing = true; update(); }, { signal });
          const paused = () => { this.pause.playing = [...this.rail.querySelectorAll('video')].some(item => !item.paused); update(); };
          video.addEventListener('pause', paused, { signal }); video.addEventListener('ended', paused, { signal });
        });
        const pauseButton = this.querySelector('[data-dd-pause]');
        pauseButton?.addEventListener('click', () => { this.pause.user = !this.pause.user; pauseButton.setAttribute('aria-pressed', String(this.pause.user)); update(); }, { signal });
        const move = direction => {
          this.pause.user = true; pauseButton?.setAttribute('aria-pressed', 'true'); update();
          const cycle = original.getBoundingClientRect().width + 16;
          if (direction < 0 && this.rail.scrollLeft < 1) this.rail.scrollLeft = cycle;
          if (direction > 0 && this.rail.scrollLeft >= cycle - 1) this.rail.scrollLeft = 0;
          this.rail.scrollBy({ left: direction * (original.firstElementChild.getBoundingClientRect().width + 16), behavior: this.motion.matches ? 'auto' : 'smooth' });
        };
        this.querySelector('[data-dd-prev]')?.addEventListener('click', () => move(-1), { signal });
        this.querySelector('[data-dd-next]')?.addEventListener('click', () => move(1), { signal });
        this.rail.addEventListener('keydown', event => { if (event.target === this.rail && ['ArrowLeft','ArrowRight'].includes(event.key)) { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); } }, { signal });
        document.addEventListener('visibilitychange', update, { signal });
        this.motion.addEventListener('change', update, { signal });
        this.observer = new IntersectionObserver(entries => { this.onScreen = entries[0].isIntersecting; update(); }, { threshold: .1 });
        this.observer.observe(this); this.stop = stop;
      }
      disconnectedCallback() { this.stop?.(); this.observer?.disconnect(); this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-reviews"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('dd-review-feed')) {
  customElements.define('dd-review-feed', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.loading = false;
      this.cards = [...this.querySelectorAll('[data-dd-review]')];
      this.button = this.querySelector('[data-dd-more]');
      this.status = this.querySelector('[data-dd-review-status]');
      this.visible = window.Shopify?.designMode ? this.cards.length : 4;
      this.cards.forEach((card, i) => { card.hidden = i >= this.visible; });
      if (this.button) this.button.hidden = this.cards.length <= this.visible && !this.button.dataset.nextUrl;
      this.button?.addEventListener('click', async event => {
        event.preventDefault();
        if (this.loading) return;
        const first = this.cards[this.visible];
        if (this.visible < this.cards.length) {
          this.visible += 4;
          this.cards.forEach((card, i) => { card.hidden = i >= this.visible; });
          this.button.hidden = this.visible >= this.cards.length && !this.button.dataset.nextUrl;
          this.announce(Math.min(this.visible, this.cards.length), first);
          return;
        }
        if (this.dataset.source !== 'library' || !this.button.dataset.nextUrl) {
          this.button.hidden = true;
          return;
        }
        this.loading = true;
        this.button.setAttribute('aria-disabled', 'true');
        this.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(this.button.dataset.nextUrl, location.href);
          if (url.origin !== location.origin) throw new Error('Invalid review URL');
          url.hash = ''; url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: this.abort.signal });
          if (!response.ok) throw new Error('Unable to load reviews');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const feed = doc.querySelector('dd-review-feed[data-source="library"]');
          if (!feed || feed.dataset.sectionId !== this.dataset.sectionId) throw new Error('Invalid review response');
          const seen = new Set(this.cards.map(card => card.dataset.reviewId));
          const cards = [...feed.querySelectorAll('[data-dd-review]')].filter(card => !seen.has(card.dataset.reviewId));
          if (!cards.length) throw new Error('No new reviews returned');
          cards.forEach(card => card.hidden = true);
          this.querySelector('.dd-story__review-grid').append(...cards);
          this.cards.push(...cards);
          const next = feed.querySelector('[data-dd-more]');
          if (next?.dataset.nextUrl) this.button.dataset.nextUrl = next.dataset.nextUrl;
          else delete this.button.dataset.nextUrl;
          const revealFrom = this.visible;
          this.visible += 4;
          this.cards.forEach((card, i) => { card.hidden = i >= this.visible; });
          this.button.hidden = this.visible >= this.cards.length && !this.button.dataset.nextUrl;
          this.announce(Math.min(this.visible, this.cards.length), this.cards[revealFrom]);
        } catch (error) {
          if (error.name !== 'AbortError' && this.status) this.status.textContent = this.status.dataset.error;
        } finally {
          this.loading = false;
          this.button.removeAttribute('aria-disabled');
          this.removeAttribute('aria-busy');
        }
      }, { signal: this.abort.signal });
    }
    announce(count, first) {
      if (this.status) this.status.textContent = count + ' ' + this.status.dataset.label;
      if (first) { first.tabIndex = -1; first.focus({ preventScroll: true }); }
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
